
import React, { createContext, useContext, useState, useEffect, act } from 'react';
import { putData, postData, fetchData } from './Api';


const SubscriptionContext = createContext({
  activePlan: { plan: null, yearly: null, canceled: null},
  subscriptions: null,
  setActivePlan: () => {},
  getCurrentSubscription: () => {},
  handleUpgradeFreeToBasic: () => {},
  handleCreateSubscription: () => {},
  handleCancelActiveSubscription: () => {},
  handleRenewSubscription: () => {},
  setToInitialState: () => {}
});

export const SubscriptionContextProvider = ({ children }) => {

  const initState =  { plan: null, yearly: null, canceled: null};

  const [activePlan, setActivePlan] = useState(() => {
    return JSON.parse(localStorage.getItem("activePlan")) || initState;
  });

  const setToInitialState = () => {
    setActivePlan(initState);
  }

  useEffect(() => {
    if (activePlan) {
      localStorage.setItem("activePlan", JSON.stringify(activePlan));
    }
  }, [activePlan]);

  const getCurrentSubscription = async () => {
    try {
      const response = await fetchData(`/api/v1/subscription`);
      setActivePlan(response.data);
    } catch (error) {
      setActivePlan(initState);
      if (error.status !== 404 && error.status !== 401 && error.status !== 403) {
        console.log("Error occurred while getting subscription", error.status);
      }
    }
  };

  // upgrade from free to basic
  const handleUpgradeFreeToBasic = async (selectedPlan, isYearly) => {
    const payload = {
        plan: selectedPlan.name, 
        id: selectedPlan.id,
        yearly: isYearly
    };
    try {
        const response = await putData(`/api/v1/subscription/upgrade`, payload);
        setActivePlan(response.data);
    } catch (error) {
        console.log("Unknown error occurred while upgrading subscription", error.status);
    }
  };

  const handleCreateSubscription = async (selectedPlan, isYearly) => {
      const payload = {
          plan: selectedPlan.name, 
          id: selectedPlan.id,
          yearly: isYearly 
      };
      try {
          const response = await postData(`/api/v1/subscription/create`, payload);
          setActivePlan(response.data);
      } catch (error) {
          console.log("Unknown error occurred while creating subscription", error.status);
      }
  };

  const handleCancelActiveSubscription = async () => {
      try {
          const response = await putData(`/api/v1/subscription/cancel`);
          setActivePlan(response.data);
      } catch (error) {
          console.log("Error cancelling the subscription", error.status);
      }
  };

  const handleRenewSubscription = async () => {
      try {
          const response = await putData(`/api/v1/subscription/renew`);
          setActivePlan(response.data);
      } catch (error) {
          console.log("Unknown error occurred while renewing subscription", error.status);
      }
  };

  return (
      <SubscriptionContext.Provider value={{ 
          activePlan,
          setActivePlan,
          getCurrentSubscription,
          handleUpgradeFreeToBasic,
          handleCreateSubscription,
          handleCancelActiveSubscription,
          handleRenewSubscription,
          setToInitialState
        }}>
        {children}
      </SubscriptionContext.Provider>
    );
}

export const useSubscription = () => useContext(SubscriptionContext);
